// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3_S2K","footer":"Form_footer__3qfEK"};